import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Index from "@/views/Index";
import Home from "@/views/home/Home";
import Archives from "@/views/archives/Archives";
import Blog from "@/views/blog/Blog";
import BlogWrapper from "@/views/blog/BlogWrapper";
import Tag from "@/views/tag/Tag";
import Category from "@/views/category/Category";
import Moments from "@/views/moments/Moments";
import Friends from "@/views/friends/Friends";
import About from "@/views/about/About";
import Login from "@/views/Login";
import AllBlogs from "@/views/AllBlogs"
import axios from '@/plugins/axios'
import {Message} from "element-ui";

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		component: Login,
		meta: {
			title: 'Login'
		}
	},
	{
		path: '/',
		component: Index,
		redirect: '/home',
		children: [
			{
				path: '/home',
				name: 'home',
				component: Home,
				meta: {
					title: 'Home'
				}
			},

		]		
	},
	{
		path: '/category/:name',
		name: 'category',
		component: Category,
		meta: {
			title: 'Category'
		}
	},
	
	{
		path: '/archives',
		name: 'archives',
		component: Archives,
		meta: {
			title: 'Archives'
		}
	},
	{
		path: '/blogs',
		name: 'AllBlogs',
		component: AllBlogs,
		meta: {
			title: 'All blogs'
		}
	},
	{
		path: '/tag/:name',
		name: 'tag',
		component: Tag,
		meta: {
			title: 'Tag'
		}
	},
	{
		path: '/moments',
		name: 'moments',
		component: Moments,
		meta: {
			title: 'Moments'
		}
	},
	{
		path: '/friends',
		name: 'friends',
		component: Friends,
		meta: {
			title: 'Friends'
		}
	},
	{
		path: '/about',
		name: 'about',
		component: About,
		meta: {
			title: 'About me'
		}
	},
	{
		path: '/:blogTitle',  
		component: BlogWrapper,
		children: [
			{
			  path: '', 
			  name: 'blogByTitle',
			  component: Blog,
			  props: route => ({ id: route.meta.blogId }),
			},
		],
		beforeEnter: async (to, from, next) => {
			try {
				const title = to.params.blogTitle;
				const blogId = await getBlogIdByTitle(title);
				if (blogId) {
					to.meta.blogId = blogId;
					next();
				}  else {
					next('/'); 
				}
			} catch (error) {
				Message.error("请求失败")
				next('/');
			}
		}
	},
	{
		path: '/blog/:id',
		name: 'blog',
		component: Blog,
		props: true,
		meta: {
			title: 'Blog'
		}
	},
	// {
	// 	path: "/:blogTitle",
	// 	name: "blogByTitle",
	// 	component: Blog,
	// 	meta: { title: 'Blog'}
	// },
	
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

//挂载路由守卫
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		if (store.state.siteInfo.webTitleSuffix) {
			// document.title = to.meta.title + store.state.siteInfo.webTitleSuffix
			document.title = to.meta.title
		} else {
			document.title = to.meta.title
		}
	}
	next()
})
function getBlogIdByTitle(title) {
	return axios({
			url: 'getBlogIdByTitle',
			method: 'Get',
			params: {
				title
			}
		})
	  .then(response => {
		// console.log(response)
		if (response.data!=null) {
		  return response.data; 
		} else {
			Message.error("There is no relevant article!")
		}
	  })
	  .catch(error => {
		console.error("获取文章ID失败：", error);
		throw error;
	  });
}
export default router
